export default {
  computed: {
    $room() {
      return this.$store.state.room.room
    },
    $me() {
      return this.$store.state.room.me
    },
  }
}
